'use strict';

document.body.className += ' ' + 'js-loaded';
document.body.className = document.body.className.replace('no-js','');

bedrock.require({url:"/services/javascripts/currencies.js"},{ url:"//cdn.shopify.com/s/files/1/2161/7185/t/32/assets/jquery.currencies.min.js?v=2314" }).then(function(){
  bedrock.require({ url:"//www.vitalityandwellness.com.au/cdn/shop/t/32/assets/site.js?v=1.845&v=23397050390511108641688342647" }).then(function(){$(function(){ // jQuery loaded
  
      // Test jquery console.log($('main'));
      //console.log('view version: 1.745');

      let state = {};
          window.state = state;

      //Site
      let vw = Object.create(website);

      Currency.format = 'money_format';

      // Objects
      let $contact_form = $('.contact-form'),
      $body = $('body'),
      $window =  $(window),
      $searchOverlay = $('#search'),
      productItem = $('.grid-block.product-item'),
      collectionPage = $('.collection-products-section'),
      productPage = $('.product-detail-page'),
      mobileNav = $('#mobile-nav'),
      $mainCart = $('#main-shopping-cart-section');

      // Profiler - Testing
      //let profileData = vw.userProfiler.ipInfoDataCollect();
      //console.log(profileData);

      // Site loading code
      vw.siteLoad();

      // Mobile Nav
      mobileNav.mmenu({
          "navbar": {
            add: true,
            title: "Vitality &amp; Wellness"
          },
          position:"right",
          offCanvas: false,
          setSelected: false,
          navbars: [
            {
              "position": "bottom",
              "content": [
                
              ]
            }
          ],
          searchfield: {
            add: true,
            search: false,
            position: "top",
            placeholder: "Search"
          },
          "extensions": [
            "theme-white","offCanvas"
          ],
          offCanvas: { 
              pageSelector: "#site",
              position: "right",
              zposition : "back"
          }
        },
        {
          searchfield: {
            "form": {
              "action": "/search"
            },
            "input": {
              "name": "q"
            }
          }
      });

      // Checkout nav
      $('#cart').mmenu({
        navbar: {
          add: true,
          title: "Shopping Cart"
        },
        position:"right",
        offCanvas: false,
        setSelected: false,
        "extensions": [
          "theme-white","offCanvas"
        ],
        offCanvas: {
          pageSelector: "#site",
          zposition: 'front',
          position: 'right'
        },
        
      });

      $('.close-cart').on('click',function() {
        $('#cart').removeClass('mm-opened').removeClass('mm-current');
        $('#panel-cart').removeClass('mm-opened');
    });

      $('.cart-button, .icon-menu').on("click", function(e) {
        $('#search').hide();
      });

      vw.cart.slideoutCart();
      vw.userProfiler.userProfileClasses();
      vw.currency.loadedCurrency();
      vw.currency.globalCurrencyPageload();
      vw.contentTabs($('ul.tabs'));

      if ( $('.article-content').length ){
        vw.responsiveYoutube('.article-content iframe[src*="youtube"]');
        vw.responsiveVimeo('.article-content iframe[src*="vimeo"]');
      }

      if ( $('.product-description').length ){
        vw.responsiveYoutube('.product-description iframe[src*="youtube"]');
        vw.responsiveVimeo('.product-description iframe[src*="vimeo"]');
      }

      $('select#currency-switcher').on('change', function(e){
        let newCurrency = $(this).val();
        vw.currency.currencyChange(newCurrency);
      });

      if( $('.login-form').length ){
        vw.login.forgotPassword();
        vw.login.loginRedirect();
      }

      $contact_form.each(function() {
          const $cf = $(this);
          let successMessage  = $cf.data('successmessage');
          if ( successMessage == undefined ){
            if ( $cf.parent().hasClass('newsletter') ){
              successMessage = "Thank you for joining our mailing list!";
            }else{
              successMessage = "Thank you for submitting";
            }
              
          }

          $cf.on('submit', function(e){
              if($('input[name="challenge"]', $cf).val() !== "true") {
                  $.ajax({
                  type: $cf.attr('method'),
                  url: $cf.attr('action'),
                  data: $cf.serialize(),
                  success: function (data) {
                      $cf.fadeOut("slow", function(){
                      $cf.before('<p class="message">' + successMessage + '</p>');
                      });
                  },
                  error: function(data) {
                      $('input[name="challenge"]', $cf).val('true');
                      $cf.submit();
                  }
                  });
                  e.preventDefault();
              }
          });
      });      

      $('#search-toggle').on('click',function(e){
          e.preventDefault();
          $(this).toggleClass('active-search');
          $searchOverlay.toggleClass('active-search');
      });

      $('#search .search-close').on('click',function(){
          $('#search-toggle').removeClass('active-search');
          $searchOverlay.removeClass('active-search');
      });

      if ($(".map-section .map, .contact-template-section .map, .page-details-section .map").hasClass('js-api-map')) {
          vw.maps.mapsLoad();
      }

      if ( $mainCart.length ){
        vw.cart.mainCart();
      }

      if ( $('.template-index').length ){
        var swiper = new Swiper('.testi-container', {
          navigation: {
            nextEl: '.testi-container .swiper-button-next',
            prevEl: '.testi-container .swiper-button-prev',
          },
        });
      }

      if ( collectionPage.length ){
          vw.imageLoader('lazy-image');
      }

      if ( collectionPage.length || productPage.length ){
          let checkForAccessCookie = website.restrictions.cookieAccess();
          if ( checkForAccessCookie == false ){
            vw.restrictions.countryAccess();
          }
      }

      if ( $('.promo_banner').length ){
        $body.addClass('promo-banner-active');
      }

      if( productPage.length ){
          vw.products.productPage.pageLoad();
          vw.products.productPage.productImages();
          vw.products.productPage.stockController();
          vw.products.productPage.addToCart();
          vw.restrictions.restrctionForm();

          $('body').on('click','.exit-page',function(e){

            var ref = document.referrer;
        
            function prodLinker(){
              var rlink = $('.breadcrumb.collections-breadcrumb > span:nth-child(3) > a').attr('href');
              
              if ( rlink != undefined && rlink != "" ){
                window.location.href = rlink;
              }else{
                window.location.href = "https://www.vitalityandwellness.com.au";
              }
            }
            
            if (ref.indexOf("vitalityandwellness") > -1) {
              if ( ref == undefined ||  ref == ""){
                prodLinker();
              }else{
                window.history.back();
              }
            }else{
              prodLinker();
            }
        
          });
      }

      if ( $('.banner-slider-section') ){
          vw.sections.bannerSlider($('.banner-slider-section'));
      }

    $window.scroll(function(){
        if ($window.scrollTop() > 50) {
          $body.addClass('scrolling');
        } else {
          $body.removeClass('scrolling');
        }

      });

  });});
});